export function sortObjectsById<T>(
    arrayOfObjects: T[],
    idExtractor: (obj: T) => string
): T[] {
    return arrayOfObjects.slice().sort((objectA, objectB) => {
        const idA = Number(idExtractor(objectA))
        const idB = Number(idExtractor(objectB))

        return idA - idB
    })
}
